import {useQuery} from 'react-query'
import api from '../api'
import {params} from '../commonTypes'

export const useGetAvailabilityHistoryQuery = (params: params.GetAvailabilityHistory) => {
  return useQuery(['getAvailabilityHistory', params], () => api.getAvailabilityHistory(params))
}
